module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_Notes_EVENTS_1961_1_FPO.005091a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_Notes_EVENTS_1961_1_FPO.jpg
// module id = k67B
// module chunks = 0